export default function formatNumber(number, decimal = 2) {
    const n = parseFloat(number).toFixed(decimal);
    return n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}
